<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<el-button  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加題目</el-button>
					<el-button class="mr-2" type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>
					
					<el-upload
						action="/admin/data/importExcelTopic"  
						:before-upload="beforeUpload"
						:headers="{token:$store.state.user.token}"
						:on-success="handleSuccess"
						:on-error="handleError"
						
						:show-file-list="false"
						accept=".xlsx,.xls"
					>
						<el-button class="mr-2" type="warning" size="mini">點擊上傳Excel文件</el-button>
					</el-upload>
				</template>


				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="from" :model="from" label-width="100px">
						<el-form-item label="題目編號" class="mb-0">
							<el-input size="small" v-model="from.topic_no" placeholder="搜索編號"></el-input>
						</el-form-item>

						<el-form-item label="題目" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜索題目"></el-input>
						</el-form-item>

						<el-form-item label="反饋次數" class="mb-0">
							<el-input size="small" v-model="from.report_num" placeholder="搜索反饋次數"></el-input>
						</el-form-item>
					
						<el-form-item label="難度" prop="difficulty">
							<el-select size="small" v-model="from.difficulty">
								<el-option label="全部" :value=0></el-option>
								<el-option label="難度-1" value="1"></el-option>
								<el-option label="難度-2" value="2"></el-option>
								<el-option label="難度-3" value="3"></el-option>
								<el-option label="難度-4" value="4"></el-option>
								<el-option label="難度-5" value="5"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="答對率%" class="mb-0">
							<el-input size="small" v-model.number="from.correct_rate_min" placeholder="最小" type="number" min="0" max="100" style="width: 80px;"></el-input>
							<span class="mx-1">至</span>
							<el-input size="small" v-model.number="from.correct_rate_max" placeholder="最大" type="number" min="0" max="100" style="width: 80px;"></el-input>
						</el-form-item>
					
						<el-form-item label="學科類型" prop="subject_id">
							<el-select size="small"  @change="changeTypeFrom"  v-model="from.subject_id">
								<el-option label="全部" :value=0></el-option>
								<el-option
								v-for="item in subject_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="標籤"   prop="label_id">
							<el-select size="small" v-model="from.label_id">
								<el-option label="全部" :value=0></el-option>
								<el-option
								v-for="item in label_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="年級"   prop="grade_id">
							<el-select size="small" v-model="from.grade_id">
								<el-option label="全部" :value=0></el-option>
								<el-option
								v-for="item in grade_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋</el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">

				</el-table-column>
			<!-- 	<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->

				<el-table-column align="center" prop="topic_no" label="題目编號">
				</el-table-column>

				<el-table-column align="center" prop="grade_name"  label="年級">
					<template slot-scope="v">
						<span>
							<el-tag type="success">{{v.row.grade_name}}</el-tag>
						</span>
					</template>
				</el-table-column>
			
				<el-table-column align="center" prop="title" label="題目">
					<template slot-scope="scope">
						<div v-if="scope.row.title.length > 30">
							{{ scope.row.title.substring(0, 30) }}... 
							<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
						</div>
						<div v-else>
							{{ scope.row.title }}
						</div>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="subject_name"  label="學科類型">
					<template slot-scope="v">
						<span>
							<el-tag >{{v.row.subject_name}}</el-tag>
						</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center"  prop="label_name"  label="標籤">
					<template slot-scope="v">
						<span>
							<el-tag type="warning">{{v.row.label_name}}</el-tag>
						</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="score" label="默認分數">
				</el-table-column>

				<el-table-column align="center" prop="sel_num" label="被選回答次數">
				</el-table-column>
				
				<el-table-column align="center" prop="yes_num" label="正確回答次數">
				</el-table-column>

				<el-table-column align="center" width="100" prop="correct_rate" label="答對率">
					<template slot-scope="scope">
						<span>{{ scope.row.correct_rate != null ? scope.row.correct_rate + '%' : '-' }}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="report_num" label="反饋次數">
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="200" label="創建時間">
				</el-table-column>
				
				<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">操作</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'add'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加題目':'修改題目'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'60%'" @opened="scrollToTop">
		<div  ref="dialogContent" style="max-height: 65vh; overflow: auto;">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
			
				<el-form-item  label="題目图片" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'1',cms_type:'2'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.icon" :src="form.icon" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

				<el-form-item  label="題目類型"  prop="topic_type" >
						<el-radio-group v-model="form.topic_type" :disabled="editIndex>0?true:false">
							<el-radio :label="1">選擇題</el-radio>
							<el-radio :label="2">填空題</el-radio>
						</el-radio-group>
				</el-form-item>								
				
				<el-form-item label="年級"  prop="grade_id">
					<el-select  v-model="form.grade_id">
						<el-option
						v-for="item in grade_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="學科類型"   prop="subject_id">
					<el-select @change="changeType" v-model="form.subject_id">
						<el-option
						v-for="item in subject_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="題目標籤"   prop="label_id">
					<el-select v-model="form.label_id">
						<el-option
						v-for="item in label_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
						<el-option v-if="label_list.length === 0" disabled value="">暂无可选標籤</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="難度" prop="difficulty">
					
						<el-rate
							style="line-height: 49px;"
							v-model="form.difficulty"
							:colors="colors">
						</el-rate>
				
				</el-form-item>

				<el-form-item label="題目（中文）" prop="title">
					<el-input type="textarea" :rows="8" v-model="form.title" 
					placeholder="題目（中文）" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="題目（英文）" prop="title_en">
					<el-input type="textarea" :rows="8" v-model="form.title_en" 
					placeholder="題目（英文）" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<div v-if="form.topic_type == 1">
					<el-form-item label="選項A" prop="option_a">
						<div style="display: flex; align-items: center; margin-bottom: 10px;">
							<el-input type="text" v-model="form.option_a" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項A（中文）"></el-input>
							<el-input type="text" v-model="form.option_a_en" clearable size="small" style="width: 85%;" placeholder="選項A（英文）"></el-input>
							<el-radio v-model="form.answer_o" label="a" style="margin-left: 10px;">正確答案</el-radio>
						</div>
					</el-form-item>

					<el-form-item label="選項B" prop="option_b">
						<div style="display: flex; align-items: center; margin-bottom: 10px;">
							<el-input type="text" v-model="form.option_b" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項B（中文）"></el-input>
							<el-input type="text" v-model="form.option_b_en" clearable size="small" style="width: 85%;" placeholder="選項B（英文）"></el-input>
							<el-radio v-model="form.answer_o" label="b" style="margin-left: 10px;">正確答案</el-radio>
						</div>
					</el-form-item>

					<el-form-item label="選項C" prop="option_c">
						<div style="display: flex; align-items: center; margin-bottom: 10px;">
							<el-input type="text" v-model="form.option_c" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項C（中文）"></el-input>
							<el-input type="text" v-model="form.option_c_en" clearable size="small" style="width: 85%;" placeholder="選項C（英文）"></el-input>
							<el-radio v-model="form.answer_o" label="c" style="margin-left: 10px;">正確答案</el-radio>
						</div>
					</el-form-item>

					<el-form-item label="選項D" prop="option_d">
						<div style="display: flex; align-items: center; margin-bottom: 10px;">
							<el-input type="text" v-model="form.option_d" clearable size="small" style="width: 85%; margin-right: 10px;" placeholder="選項D（中文）"></el-input>
							<el-input type="text" v-model="form.option_d_en" clearable size="small" style="width: 85%;" placeholder="選項D（英文）"></el-input>
							<el-radio v-model="form.answer_o" label="d" style="margin-left: 10px;">正確答案</el-radio>
						</div>
					</el-form-item>
				</div>
				<div v-else>
					<el-form-item>
						<el-button type="primary" @click="addAnswer">新增答案</el-button>
					</el-form-item>

					<el-form-item label="答案" prop="answer">
						<div v-for="(answer, index) in form.answer" :key="index" style="display: flex; align-items: center;">
							<el-input
							type="text"
							v-model="form.answer[index]"
							placeholder="輸入答案"
							clearable
							size="small"
							style="width: 85%; margin-right: 10px;">
							</el-input>
							<el-button
							type="danger"
							icon="el-icon-delete"
							size="small"
							:disabled="form.answer.length === 1"
							@click="removeAnswer(index)">
							刪除
							</el-button>
						</div>
					</el-form-item>
				</div>
				
				<el-form-item label="默認分數" prop="score">
					<el-input type="text" v-model="form.score" 
					placeholder="題目默認分數" 
					clearable size="small" style="width: 85%;">
					
					</el-input>
				</el-form-item>
				
					
				<el-form-item label="解釋" prop="explanation">
					<el-input type="textarea" :rows="4" v-model="form.explanation" class="content_huan"
					placeholder="解釋" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			</el-form>
		</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		
		<!-- 弹出框，用于顯示完整題目 -->
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisible" title="題目">
		<p>{{ fullTitle }}</p>
		</el-dialog>
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogVisible: false,
				fullTitle: '',
				colors: ['#99A9BF', '#F7BA2A', '#FF9900'],  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
				rules: {
					title: [{
							required: true,
							validator: (rule, value, callback) => {
								if (!value) {
									callback(new Error('請輸入題目'));
								} else {
									let chineseCount = (value.match(/[\u4e00-\u9fa5]/g) || []).length;  // 统计中文字符
									let englishCount = value.length - chineseCount;  // 统计英文字符

									if (chineseCount > 200) {
										callback(new Error('內容不能超過200个中文字符'));
									} else if (englishCount > 400) {
										callback(new Error('內容不能超過400个英文字符'));
									} else {
										callback();  // 验证通过
									}
								}
							},
							trigger: 'blur',
						},
					],
					answer: [
						{ 
							required: true, 
							validator: (rule, value, callback) => {
								// 检查 answer 數組中的每一个元素是否为空
								if (value.some(answer => !answer)) {
									callback(new Error("答案不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					option_a: [{
							required: true,
							message: "选项A不能為空",
							trigger: 'blur',
						},
					],
					option_b: [{
							required: true,
							message: "选项B不能為空",
							trigger: 'blur',
						},
					],
					option_c: [{
							required: true,
							message: "选项C不能為空",
							trigger: 'blur',
						},
					],
					option_d: [{
							required: true,
							message: "选项D不能為空",
							trigger: 'blur',
						},
					],
					label_id: [{
							required: true,
							message: "請選擇標籤",
							trigger: 'blur',
						},
					],
					difficulty: [{
							required: true,
							message: "請選擇題目難度",
							trigger: 'blur',
						},
					],
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					title: '',
					difficulty:0,
					report_num:'',
					correct_rate_min: '',
					correct_rate_max: '',
					subject_id:0,
					grade_id:0,
					label_id:0,
					topic_no:'',
					topoc_type: 0,
					time:[]
				},
				model_title: 'Topic',
				auth_val: 'Topic',
				preUrl: "data/topicList", //列表地址
				addUrl: "data/addTopic", //添加/修改地址
				delAllUrl: "data/delTopicAll", //批量刪除地址
				delUrl: "data/delTopic", //刪除單条地址
				editStatusUrl: "data/editStatusTopic", //修改狀態地址
				tableData: [],
				form: {
					title:'',
					title_en:'',
						answer:[''],
						img:'',
						score:10,
						topic_type:1,
						grade_id:null,
						subject_id:null,
						label_id:null,
						icon:'',
						option_a:'',
						option_a_en:'',
						option_b:'',
						option_b_en:'',
						option_c:'',
						option_c_en:'',
						option_d:'',
						option_d_en:'',
						explanation:'',
						answer_o: 'a',
						difficulty:1,
				},

				labels: ['A', 'B', 'C', 'D'], // 可根据需要增加更多的標籤
				prop: 'id',
				sort: 'descending',

				label_list: [],
				all_label_list: [],
				subject_list: [],
				grade_list: [],

				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
			}
		},
		
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			'form.topoc_type'(newVal, oldVal) {
			if (newVal === 2 || oldVal === 2) {
				this.$nextTick(() => {
				this.$refs.form.clearValidate();
				});
			}
			},
			'form.topic_option.length'() {
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
			// 监听 subject_id 的变化
			'form.subject_id': function(newVal) {
				
			}
		},
		created() {
			this.commonList(['topic_subject_label','grade_list']);
		},
		methods: {
			scrollToTop() {
				// 獲取滾動容器並設置滾動條位置
				const content = this.$refs.dialogContent;
				if (content) {
					content.scrollTop = 0; // 將滾動條設置到頂端
				}
			},
			 // 顯示完整題目内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogVisible = true;
			},
			// 上傳前的文件類型检查
			beforeUpload(file) {
				const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
				if (!isExcel) {
					this.$message.error('只能上傳Excel文件');
				}
				this.layout.loading = true;  // 控制加載层的顯示
				return isExcel;
			},
			// 上傳成功回调
			handleSuccess(res, file, fileList) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res = JSON.parse(en_data)
				this.layout.loading = false;  // 控制加載层的顯示
				if(res.code==0){
					this.$message.error(res.msg);
				}else{
					this.$message.success('文件上傳成功');
					this.getList()
				}
			},
			// 上傳失敗回调
			handleError(error, file, fileList) {
				this.layout.loading = false;  // 控制加載层的顯示
				this.$message.error('文件上傳失敗');
			},
			// 添加一个新的答案輸入框
			addAnswer() {
				this.form.answer.push(''); // 每次點擊新增按钮，往數組中添加一个空字符串
			},
			// 刪除对应的答案輸入框
			removeAnswer(index) {
				this.form.answer.splice(index, 1); // 刪除指定索引的答案
			},
			changeType(){
				// 设置label_list并處理可能的空值
				this.label_list = this.all_label_list[this.form.subject_id] || [];
				if (this.label_list.length > 0) {
					// 如果label_list不为空，则设置默認选中项为第一个元素的ID
					if(this.editIndex == -1){
						this.form.label_id = this.label_list[0].id;
					}
				} else {
					// 如果label_list为空，可以设置label_id为null或其他逻辑處理
					this.form.label_id = null;
				}
			},
			changeTypeFrom(){
				console.log(this.from.subject_id)
				this.label_list = this.all_label_list[this.from.subject_id] || [];
				this.from.label_id = 0; // 设置默認的label_id
			},
			removeDomain(item) {
				var index = this.form.topic_option.indexOf(item)
				if (index !== -1) {
					this.form.topic_option.splice(index, 1)
				}
			},
			addDomain() {
				if (this.form.topic_option.length >= this.labels.length) {
					this.$notify({
						title: '警告',
						message: '无法添加更多的选项',
						type: 'warning'
					});
					return;
				}
				const label = this.labels[this.form.topic_option.length];
				this.form.topic_option.push({
					value: '',
					label: label,
					key: Date.now()
				});
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.subject_list = list.subject
					this.grade_list = list.grade
					this.all_label_list = list.label
					if (this.grade_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.grade_id = this.grade_list[0].id;
					}
					if (this.subject_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.subject_id = this.subject_list[0].id
						this.label_list = list.label[this.subject_list[0].id]
						if (this.label_list.length > 0) {
							// 设置默認选中项为subject_list中的第一个元素
							this.form.label_id = this.label_list[0].id;
						}
					}
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},


			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						if (this.form.topoc_type === 2 && this.form.topic_option.length < 2) {
							this.$message.error('选项不能少于两个');
						} else {
							// 验证英文标题和选项的一致性：要么全部为空，要么全部有值
							if (this.form.topic_type == 1) {
								const hasTitleEn = this.form.title_en && this.form.title_en.trim() !== '';
								const hasOptionAEn = this.form.option_a_en && this.form.option_a_en.trim() !== '';
								const hasOptionBEn = this.form.option_b_en && this.form.option_b_en.trim() !== '';
								const hasOptionCEn = this.form.option_c_en && this.form.option_c_en.trim() !== '';
								const hasOptionDEn = this.form.option_d_en && this.form.option_d_en.trim() !== '';
								
								// 统计有值的数量
								const filledCount = [hasTitleEn, hasOptionAEn, hasOptionBEn, hasOptionCEn, hasOptionDEn].filter(Boolean).length;
								
								// 如果有部分有值（不是0也不是5），则不符合要求
								if (filledCount > 0 && filledCount < 5) {
									this.$message.error('英文標題和所有選項的英文必須同時填寫或同時為空，不能部分填寫');
									return;
								}
							}
							
							this.form.id = this.editIndex
							this.addOrEdit(this.form)
						}
					}
				})
			},
			
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			},

			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},

			// 打开模态框
			openModel(e, type) {
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						title_en: e.title_en || '',
						answer: e.answer,
						icon:e.img,
						subject_id:e.subject_id,
						grade_id:e.grade_id,
						score:e.score,
						topic_type:e.topic_type,
						
						label_id:e.label_id,
						option_a:e.option_a,
						option_a_en:e.option_a_en || '',
						option_b:e.option_b,
						option_b_en:e.option_b_en || '',
						option_c:e.option_c,
						option_c_en:e.option_c_en || '',
						option_d:e.option_d,
						option_d_en:e.option_d_en || '',
						answer_o:e.answer_o,
						explanation:e.explanation,
						difficulty:e.difficulty,
					}
					this.editIndex = e.id
					this.changeType()
				}else{
					this.form = {
						id: 0,
						title:'',
						title_en:'',
						answer:[''],
						topic_type:1,
						score:10,
						headUrl: '',
						icon:'',
						grade_id:this.form.grade_id,
						subject_id:this.form.subject_id,
						label_id:this.form.label_id,
						option_a:'',
						option_a_en:'',
						option_b:'',
						option_b_en:'',
						option_c:'',
						option_c_en:'',
						option_d:'',
						option_d_en:'',
						explanation:'',
						answer_o: 'a',
						difficulty:1,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					title: '',
					report_num: '',
					correct_rate_min: '',
					correct_rate_max: '',
					difficulty:0,
					subject_id:0,
					grade_id:0,
					label_id:0,
					topic_no:'',
					topoc_type: 0,
					time:[]
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
